// TODO: do this: https://github.com/rydama/mailchimp-ajax-signup/blob/master/ajax-subscribe.html
export default function () {
  $('#form-newsletter-small').on('submit', function (event) {
    event.preventDefault();
    $('#mce-EMAIL').attr('value', $(this).find('[type="email"]').val());
    window.modal('newsletter');
  });
};

